let code = 'appgestao';
let codeAPI = 'genericapplication';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};